import templateComponentMap from '@/config/template-component-map';

export default {
  loading: state => state.loading,
  pageData: state => state.pageData,
  children: state => state.pageData.children || [],
  deepChildren: (state, getters) => {
    let deepChildren = [];
    getters.children.forEach((cat) => {
      deepChildren = deepChildren.concat(cat.children || []);
    });
    return deepChildren;
  },
  componentName: state => templateComponentMap[state.pageData.template],
};
